import React from "react";
import { useTheme } from "../context/ThemeContext";

/**
 * Decorative star/planet background — renders only when the Cosmic Night
 * theme is active. The star field itself is pure CSS (in cosmic-night.css);
 * this component adds the three floating planets + a recurring shooting
 * star. Render once at the root of the app — it's `position: fixed` so it
 * sits behind everything regardless of where it's mounted.
 */
export default function CosmicNightBackdrop() {
  const { isCosmicNight } = useTheme();
  if (!isCosmicNight) return null;
  return (
    <div aria-hidden="true" data-testid="cosmic-night-backdrop">
      <div className="cosmic-planet p1" />
      <div className="cosmic-planet p2" />
      <div className="cosmic-planet p3" />
      <div className="cosmic-shooting-star" />
    </div>
  );
}
